import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { ProductImage } from '../ProductImage';
import { CtaButton } from '../CtaButton';
import { showcaseIndicators } from '../../data/salesContent';
export function ProductShowcaseSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" style={{
    backgroundImage: 'radial-gradient(ellipse 50% 40% at 50% 45%, rgba(212,175,55,0.08), transparent 70%)'
  }} data-id="element-202" data-mp="6b4g3uqzbnyy">
      <div className="mx-auto max-w-6xl" data-id="element-203" data-mp="xznzpm1tzvtv">
        <SectionHeading title="Esto es todo lo que recibís" data-id="element-204" data-mp="tyc8xd7814k3" />
        <ProductImage className="mx-auto mt-12 w-full max-w-3xl" data-id="element-205" data-mp="u0yq84jwyyfi" />
        <ul className="mx-auto mt-10 flex max-w-4xl flex-wrap justify-center gap-3" data-id="element-206" data-mp="p6uivk6qkodw">
          {showcaseIndicators.map(({
          label,
          icon: Icon
        }) => <li key={label} className="flex items-center gap-2 rounded-full border border-gold/30 bg-ink-soft px-4 py-2.5" data-id="element-207" data-mp="1hogdbms8h8c5">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-208" data-mp="1cxgfmfbaim8l" />
              <span className="text-base font-semibold text-cream" data-id="element-209" data-mp="2zcv8dsk0d2po">{label}</span>
            </li>)}
        </ul>
        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-210" data-mp="34chktzs0iexf">
          <p className="text-xl text-neutral-400 md:text-2xl" data-id="element-211" data-mp="34e2kg3t6oo25">No estás comprando simplemente ebooks.</p>
          <p className="mt-4 font-display text-2xl font-black uppercase leading-tight text-cream md:text-4xl" data-id="element-212" data-mp="2qiqmlnjqehh0">
            Estás accediendo a un <span className="text-gold" data-id="element-213" data-mp="2glu9f4iw1764">sistema de trabajo</span> para tus capacitaciones.
          </p>
        </div>
        <div className="mt-10" data-id="element-214" data-mp="2lmhznnzaljza">
          <CtaButton data-id="element-215" data-mp="2lmrqfds5vv61">Quiero acceder al sistema</CtaButton>
        </div>
      </div>
    </section>;
}